import {
  COMPLAINT_TRIBUN_REQUEST,
  COMPLAINT_TRIBUN_SUCCESS,
  COMPLAINT_TRIBUN_FAILURE,
} from 'Store/constants';

const initailState = {
  data: null,
  isLoading: false,
  error: null
};

export default (state = initailState, action ) => {
  switch (action.type) {
    case COMPLAINT_TRIBUN_REQUEST:
      return { ...state, isLoading: true, error: null };
    case COMPLAINT_TRIBUN_SUCCESS:
      return { ...state, data: action.payload, isLoading: false, error: null };
    case COMPLAINT_TRIBUN_FAILURE:
      return { ...state, isLoading: false, error: null };
    default:
      return state;
  }
};